import { JAEGER_TAG_FIELD } from './jaeger-tag-field';
/** Flattened Jaeger span tag field prefix in OpenSearch: `JaegerTag.<key>`. */
export const JAEGER_TAG_PREFIX = `${JAEGER_TAG_FIELD}.`;
//# sourceMappingURL=jaeger-tag-prefix.js.map